import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import employee from '../class/employee.js';
import swal from 'sweetalert';
import "../styles/LoginPage.css";

function LoginPage() {
    const [numeroAddetto, setNumeroAddetto] = useState('');
    const navigate = useNavigate();
    const inputRef = useRef(null);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && numeroAddetto.trim() !== '') {
            const loginWS = new employee();
            loginWS.authenticate({ employee_number: numeroAddetto }).then(() => {
                navigate('/orders');
            }).catch((error) => {
                swal("Errore", error.toString(), "error");
            });
        }
    };

    useEffect(() => {
        const user_obj = new employee();
        user_obj.isLogged().then(() => {
            navigate('/orders');
        }).catch(() => {
            // Non loggato, resta sulla pagina
        });

        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    return (
        <div className="login-container">
            <form className='form-login' onSubmit={(e) => e.preventDefault()}>
                <div>
                    <h2 className='login-title'>Magazzino Alimentare</h2>
                </div>
                <div className='login-form'>
                    <div className='login-form-block'>
                        <label htmlFor="numeroAddetto">N. Addetto:</label>
                        <input
                            type="text"
                            id="numeroAddetto"
                            value={numeroAddetto}
                            onChange={(e) => setNumeroAddetto(e.target.value)}
                            onKeyDown={handleKeyDown}
                            className='login-item'
                            autoComplete="off"
                            placeholder="Scansiona il badge"
                            ref={inputRef}
                            required
                        />
                    </div>
                </div>
            </form>
        </div>
    );
}

export default LoginPage;
